import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";

/**
 * Cabecera reutilizable para pantallas de Configuración que NO usan MaestroArchivo
 * (formularios sueltos, pantallas bespoke). Replica el "badge de ícono en color de
 * marca + título + subtítulo + botón Cerrar" que MaestroArchivo trae incorporado.
 */
export default function CabeceraPantalla({
  icono,
  titulo,
  subtitulo,
  onCerrar,
  acciones, // nodos extra a la izquierda del botón Cerrar
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 1.5,
        mb: 1.5,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
      }}
    >
      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={2}
        alignItems={{ xs: "stretch", md: "center" }}
      >
        <Stack
          direction="row"
          spacing={1.5}
          alignItems="center"
          sx={{ flexShrink: 0 }}
        >
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: 2,
              display: "grid",
              placeItems: "center",
              bgcolor: "primary.main",
              color: "primary.contrastText",
            }}
          >
            {icono}
          </Box>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
              {titulo}
            </Typography>
            {subtitulo ? (
              <Typography variant="caption" color="text.secondary">
                {subtitulo}
              </Typography>
            ) : null}
          </Box>
        </Stack>

        <Box sx={{ flexGrow: 1 }} />

        {acciones}

        {onCerrar ? (
          <Button
            variant="text"
            color="inherit"
            startIcon={<CloseIcon />}
            onClick={onCerrar}
          >
            Cerrar
          </Button>
        ) : null}
      </Stack>
    </Paper>
  );
}
